import React from 'react';
import { BriefcaseIcon, HeartIcon, ShieldCheckIcon } from 'lucide-react';
export function FocusAreas() {
  return <section className="py-24 md:py-32 px-6 bg-white border-t border-gray-100" data-id="element-24">
      <div className="max-w-6xl mx-auto" data-id="element-25">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16" data-id="element-26">
          {/* Private Investments */}
          <div className="flex flex-col items-center text-center space-y-6" data-id="element-27">
            <div className="w-12 h-12 rounded-full bg-navy/5 flex items-center justify-center mb-2" data-id="element-28">
              <BriefcaseIcon className="w-6 h-6 text-navy" strokeWidth={1.5} data-id="element-29" />
            </div>
            <h3 className="text-2xl font-medium text-navy" data-id="element-30">
              Private Investments
            </h3>
            <p className="text-gray-600 font-light leading-relaxed" data-id="element-31">
              Long-term capital partnerships across select sectors, supporting
              founders and businesses with patient, strategic resources.
            </p>
          </div>

          {/* Philanthropy */}
          <div className="flex flex-col items-center text-center space-y-6" data-id="element-32">
            <div className="w-12 h-12 rounded-full bg-navy/5 flex items-center justify-center mb-2" data-id="element-33">
              <HeartIcon className="w-6 h-6 text-navy" strokeWidth={1.5} data-id="element-34" />
            </div>
            <h3 className="text-2xl font-medium text-navy" data-id="element-35">Philanthropy</h3>
            <p className="text-gray-600 font-light leading-relaxed" data-id="element-36">
              Strategic giving aligned with community, education, and impact,
              fostering solutions to complex societal challenges.
            </p>
          </div>

          {/* Stewardship */}
          <div className="flex flex-col items-center text-center space-y-6" data-id="element-37">
            <div className="w-12 h-12 rounded-full bg-navy/5 flex items-center justify-center mb-2" data-id="element-38">
              <ShieldCheckIcon className="w-6 h-6 text-navy" strokeWidth={1.5} data-id="element-39" />
            </div>
            <h3 className="text-2xl font-medium text-navy" data-id="element-40">Stewardship</h3>
            <p className="text-gray-600 font-light leading-relaxed" data-id="element-41">
              Responsible management of capital across generations, preserving
              legacy while adapting to a changing world.
            </p>
          </div>
        </div>
      </div>
    </section>;
}